export enum favCountTypes {
  FETCH_FAV_COUNT_REQUEST = "FETCH_FAV_COUNT_REQUEST",
  FETCH_FAV_COUNT_SUCCESS = "FETCH_FAV_COUNT_SUCCESS",
  FETCH_FAV_COUNT_FAILURE = "FETCH_FAV_COUNT_FAILURE",
}